/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     button:enabled{border-radius:8px!important;box-shadow:0 2px 4px 0 rgba(0,0,0,.08)!important;background-color:#182365!important;color:#fff}"];
export { styles as styles };
